<template>
	<div class="mx-1">
		<v-row no-gutters justify="space-between" align="center">
			<label class="text-body-2 font-weight-bold">{{ `${index + 1}つ目の選択肢` }}</label>
			<v-btn text small color="red" @click="$emit('remove-meta-option', index)">削除</v-btn>
		</v-row>
		<div v-if="metaType == 'text'" class="mt-4">
			<v-textarea v-model="meta_option.value_text" dense outlined :rules="[rules.required]" />
		</div>
		<div v-if="metaType == 'string'" class="mt-4">
			<v-text-field v-model="meta_option.value_string" dense outlined :rules="[rules.required]" />
		</div>

		<div v-if="metaType == 'integer'" class="mt-4">
			<v-text-field
				v-model="meta_option.value_integer"
				dense
				outlined
				:rules="[rules.required, rules.integerWithNegative]"
			/>
		</div>

		<div v-if="metaType == 'float'" class="mt-4">
			<v-text-field
				v-model="meta_option.value_float"
				dense
				outlined
				:rules="[rules.required, rules.floatWithNegative]"
			/>
		</div>

		<div v-if="metaType == 'date'" class="mt-4">
			<v-menu close-on-content-click transition="scale-transition" offset-y min-width="auto">
				<template v-slot:activator="{ on, attrs }">
					<v-text-field
						v-model="meta_option.value_date"
						dense
						outlined
						:rules="[rules.required]"
						readonly
						v-bind="attrs"
						v-on="on"
					></v-text-field>
				</template>
				<v-date-picker class="date-picker" v-model="meta_option.value_date" no-title locale="ja-JP">
					<v-spacer></v-spacer>
				</v-date-picker>
			</v-menu>
		</div>

		<div v-if="metaType == 'time'" class="mt-4">
			<v-text-field
				v-model="meta_option.value_time"
				dense
				outlined
				type="time"
				:rules="[rules.required]"
			/>
		</div>

		<div v-if="metaType == 'datetime'" class="mt-4">
			<!-- <v-text-field
						v-model="meta_option.value_"
						dense
						outlined
						:rules="[rules.required]"
					/> -->
			<!-- <label class="text-body-2 font-weight-bold">{{ `選択肢${index + 1}` }}</label> -->

			<v-row no-gutters>
				<v-col cols="12">
					<v-row no-gutters>
						<v-col class="pr-1" cols="4">
							<v-combobox
								v-model="year"
								dense
								outlined
								:items="years"
								:rules="[rules.required]"
								@change="changeValueDatetime"
							>
								<template v-slot:append-outer>年</template>
							</v-combobox>
						</v-col>
						<v-col class="px-1" cols="4">
							<v-combobox
								v-model="month"
								dense
								outlined
								:items="months"
								:rules="[rules.required]"
								@change="changeValueDatetime"
							>
								<template v-slot:append-outer>月</template>
							</v-combobox>
						</v-col>
						<v-col class="pl-1" cols="4">
							<v-combobox
								v-model="day"
								dense
								outlined
								:items="days"
								:rules="[rules.required]"
								@change="changeValueDatetime"
							>
								<template v-slot:append-outer>日</template>
							</v-combobox>
						</v-col>
					</v-row>
				</v-col>
				<v-col cols="12">
					<v-row no-gutters>
						<v-col class="pr-1" cols="4">
							<v-combobox
								v-model="hour"
								dense
								outlined
								:items="hours"
								:rules="[rules.required]"
								@change="changeValueDatetime"
							>
								<template v-slot:append-outer>時</template>
							</v-combobox>
						</v-col>
						<v-col class="px-1" cols="4">
							<v-combobox
								v-model="minute"
								dense
								outlined
								:items="minutes"
								:rules="[rules.required]"
								@change="changeValueDatetime"
							>
								<template v-slot:append-outer>分</template>
							</v-combobox>
						</v-col>
						<v-col class="pl-1" cols="4">
							<v-combobox
								v-model="second"
								dense
								outlined
								:items="seconds"
								:rules="[rules.required]"
								@change="changeValueDatetime"
							>
								<template v-slot:append-outer>秒</template>
							</v-combobox>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</div>
	</div>
</template>

<script>
import rules from "../../../helper/rules"

export default {
	props: {
		metaType: {
			type: String,
			required: true,
		},
		metaOption: {
			type: Object,
			required: true,
		},
		index: {
			type: Number,
			required: true,
		},
	},
	data() {
		return {
			year: null,
			month: null,
			day: null,
			hour: null,
			minute: null,
			second: null,
			rules,
		}
	},
	methods: {
		changeValueDatetime() {
			if (
				this.year != null &&
				this.month != null &&
				this.day != null &&
				this.hour != null &&
				this.minute != null &&
				this.second != null
			) {
				this.meta_option.value_datetime = `${this.year}-${this.month}-${this.day} ${this.hour}:${this.minute}:${this.second}`
			} else {
				this.meta_option.value_datetime = null
			}
		},
	},
	computed: {
		years() {
			const thisYear = new Date().getFullYear()
			const endYear = 1900
			const years = [...Array(thisYear - endYear + 1)].map((_, i) => thisYear - i)
			return years
		},
		months() {
			const months = [...Array(12)].map((_, i) => i + 1)
			return months
		},
		days() {
			const days = [...Array(31)].map((_, i) => i + 1)
			return days
		},
		hours() {
			const hours = [...Array(24)].map((_, i) => i)
			return hours
		},
		minutes() {
			const days = [...Array(60)].map((_, i) => i)
			return days
		},
		seconds() {
			const days = [...Array(60)].map((_, i) => i)
			return days
		},
		meta_option: {
			get() {
				return this.metaOption
			},
			set(newValue) {
				return this.$emit("update:metaOption", newValue)
			},
		},
	},
}
</script>
